import { Select, Tooltip } from 'antd';

import './MultiSelect.style.scss';

interface MultiSelectProps {
  value: string[];
  onChange: (value: string[]) => void;
  options: { value: string; label: string }[];
  placeholder: string;
}

const MultiSelect = ({ value, onChange, options, placeholder }: MultiSelectProps) => {
  return (
    <Select
      mode="multiple"
      maxTagCount="responsive"
      maxTagPlaceholder={(omittedValues) => (
        <Tooltip
          styles={{ root: { pointerEvents: 'none' } }}
          title={omittedValues.map(({ label }) => label).join(', ')}
        >
          <span>{placeholder}</span>
        </Tooltip>
      )}
      value={value}
      onChange={onChange}
      options={options}
      className="w-[110px] h-[32px]"
      placeholder={placeholder}
    />
  );
};

export default MultiSelect;
